import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type StepsIndicationProps = {
  steps: string[];
  currentStepIndex: number;
  className?: string;
};

const getClassNameForStep = (currentIndex, currentStepIndex) => {
  switch (true) {
    case currentIndex === currentStepIndex:
      return 'bg-primary-600 text-white';
    case currentIndex < currentStepIndex:
      return 'bg-green-500 text-white';
    default:
      return 'bg-gray-200 text-gray-600';
  }
};

export const StepsIndication = ({ steps, currentStepIndex, className }: StepsIndicationProps) => {
  const { t } = useTranslation();

  if (!steps?.length) return null;

  const getStepClassName = (index: number) =>
    twMerge('flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium', getClassNameForStep(index, currentStepIndex));

  return (
    <div className={twMerge('flex items-center justify-between border-b border-secondary-border pb-4', className ?? '')}>
      <div className='flex items-center gap-2'>
        {steps.map((stepKey, index) => (
          <div key={`${stepKey}-${index}`} className='flex items-center'>
            <div className={getStepClassName(index)}>{index < currentStepIndex ? '✓' : index + 1}</div>
            {index < steps.length - 1 && <div className='mx-2 h-0.5 w-8 bg-gray-200' />}
          </div>
        ))}
      </div>
      <span className='text-sm text-tertiary-600'>{t('COMMON:stepsIndication', { current: currentStepIndex + 1, total: steps.length })}</span>
    </div>
  );
};
